import styled from 'styled-components';
import { ReactNode } from 'react';
import { DiscardedEmptyState } from 'ui/illustrations';

const Wrapper = styled.div<{ isSection: boolean }>`
  ${({ isSection }) => (isSection ? 'grid-column: 1 / span 4' : '')};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0;
`;

const Description = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 20px;
  text-align: center;
`;

type ErrorMessageProps = {
  isSection: boolean;
  title: string;
  description: ReactNode;
  content?: ReactNode;
};

export const ErrorMessage = ({ isSection, title, description, content }: ErrorMessageProps) => {
  return (
    <Wrapper isSection={isSection}>
      <DiscardedEmptyState />
      <Title>{title}</Title>
      <Description>{description}</Description>
      {content}
    </Wrapper>
  );
};
